export interface SalesOrderPayDepositSearch {
  includePaid: boolean;
}
